<template v-loading="loading">
  <el-container>
    <el-header>
      新增客户资料
      <el-divider></el-divider>
    </el-header>

    <el-main>
      <div class="main">
        <div class="form">
          <el-form ref="form" :model="form" :rules="rules" label-width="120px" :label-position="labelPosition">
            <el-form-item label="客户名称" prop="customerName">
              <el-input v-model="form.customerName" placeholder="请填写客户公司全称"></el-input>
            </el-form-item>
            <el-form-item label="客户联系人" prop="customerContacts">
              <el-input v-model="form.customerContacts" placeholder="请填写客户联系人"></el-input>
            </el-form-item>
            <el-form-item label="客户地址" prop="customerAddress">
              <el-input v-model="form.customerAddress" placeholder="请填写客户地址"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="customerPhone">
              <el-input v-model="form.customerPhone" placeholder="请填写联系电话"></el-input>
            </el-form-item>

            <el-form-item label="报备人+手机号" prop="reportName">
              <el-input v-model="form.reportName" placeholder="如：张三 123677"></el-input>
            </el-form-item>

            <el-form-item label="客户属性" prop="customerAttribute">
              <el-input v-model="form.customerAttribute" placeholder="请填写是否为新客户 是 / 否"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="notes">
              <el-input type="textarea" v-model="form.notes"></el-input>
            </el-form-item>

            <el-form-item label="交易凭证" prop="evidence">
              <el-upload
                class="evidence-uploader"
                ref="upload"
                accept="image/jpeg,image/png,image/jpg"
                action="https://yuanteng.tech:8081/file/upload"
                multiple
                :limit="3"
                :on-exceed="handleExceed"
                list-type="picture-card"
                :before-upload="beforeEvidenceUpload"
                :on-preview="handlePictureCardPreview"
                :on-success="handleEvidenceSuccess"
                :on-remove="handleRemove">
                <i class="el-icon-plus evidence-uploader-icon"></i>
              </el-upload>

            </el-form-item>

            <el-form-item>
              <el-button size="medium" type="primary" @click="onSubmit('form')">提交</el-button>
              <el-button size="medium" @click="onBack">返回</el-button>
            </el-form-item>
          </el-form>

          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </div>

        <div class="explain">
          <h3>特别说明：</h3>
          <p>1、您所报备的客户联系人及电话只有远腾可以看到，其他人是无法看到的</p>
          <p>2、请按表格提示填写信息，信息不全不予通过</p>
          <p>3、报备时间以审核通过时间为准</p>
          <p>4、备注中请写明客户用了WEICON什么产品，证明是老客户，否则按新客户报备</p>
          <p>5、报备提交后只有远腾管理员可以删除、修改该信息，如需修改请联系您的对接人</p>
          <p>6、技术支持</p>

          <p>&nbsp;&nbsp;&nbsp;&nbsp;1） 电话 400-638-6068</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;2） 邮箱 cs@weiconyt.com </p>
        </div>
      </div>

    </el-main>
  </el-container>

</template>

<script>
export default {
  name: "AddCustomer",
  data() {
    return {
      uploadToken: {
        token: (JSON.parse(window.localStorage.getItem("access-admin"))).token//携带token
      },
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      labelPosition: 'right',
      form: {
        customerName: '',              //客户名称
        customerContacts: '',          //客户联系人
        customerAddress: '',            //客户地址
        customerPhone: '',             //联系电话
        reportName: '',                //报备人+手机号
        customerAttribute: '',         //客户属性
        notes: '',                      //备注
        userId: '',                    //标识
        evidence: []
      },
      tempEvidence: [],
      rules: {
        customerName: [
          {required: true, message: '请输入客户名称', trigger: 'blur'},
        ],
        customerContacts: [
          {required: true, message: '请输入客户联系人', trigger: 'blur'},
          {min: 2, message: '请输入完整姓名', trigger: 'blur'}
        ],
        customerAddress: [
          {required: true, message: '请输入客户地址', trigger: 'blur'},
        ],
        customerPhone: [
          {required: true, message: '请输入联系电话', trigger: 'blur'},
          {validatePhone}
        ],
        reportName: [
          {required: true, message: '请输入报备人+手机号', trigger: 'blur'},
        ],
        evidence: [
          {required: true, message: '请上传交易凭证', trigger: 'blur'},
        ]
      },
      loading: false,
      backPath: ''
    }
  },
  methods: {
    /**
     *  删除图片
     * @param file
     * @param fileList
     */
    handleRemove(file, fileList) {
      if (file) {
        this.$http.post("https://yuanteng.tech:8081/file/delete", file.response.msg).then(res => {
          if (res.data && this.form.evidence.length != 0) {
            for (let i = 0; i < this.form.evidence.length; i++) {
              if (this.form.evidence[i] == (file.response.msg)) {
                this.form.evidence.splice(i, 1);
              }
            }
          }
        })
      }
    },

    /**
     * 查看大图
     * @param file
     */
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    /**
     * 文件上传成功后，返回文件存储路径，并存起来
     * @param res
     * @param file
     */
    handleEvidenceSuccess(res, file, fileList) {
      if (res.status) {
        if (fileList.every(item => item.status == "success")) {
          this.form.evidence = fileList.map(value => value.response.msg);
        }
      } else {
        this.$message.error(res.msg);
      }
    },

    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },

    /**
     * 图片上传前的校验
     * @param file
     * @returns {boolean|boolean}
     */
    beforeEvidenceUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('仅支持jpeg/png/jpg图片类型');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    /**
     * 提交表单
     * @param form
     */
    onSubmit(form) {
      this.$refs[form].validate((valid) => {
        this.loading = true;
        if (valid) {
          if (this.form.userId) {
            this.$http.post("https://yuanteng.tech:8081/customer/save", this.form).then(res => {
              if (res.data.status) {
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                });
                this.$refs[form].resetFields();
                this.$refs.upload.clearFiles();
              } else {
                this.$message.error(res.data.msg);
              }
            }).finally(() => {
              this.loading = false;
            });
          } else {
            this.$message.success('请先登录！')
            this.$router.push('/login');
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    onBack() {
      this.$router.push(this.backPath);
    },
    handleResize() {
      if (window.innerWidth < 456) {
        this.labelPosition = "top";
      } else {
        this.labelPosition = "right";
      }
    }
  },
  created() {
    const username = (JSON.parse(window.localStorage.getItem("access-admin"))).username || '';
    this.form.userId = decodeURIComponent(window.atob(username));
    this.handleResize();
    window.addEventListener('resize', this.handleResize);

    this.backPath = this.$route.params.back ? this.$route.params.back : '/index/customer';
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
}

// 电话号码验证
export function validatePhone(rule, value, callback) {
  const mobilereg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/ // 手机
  const phonereg = /^0\d{2,3}-?\d{7,8}$/ // 固话
  const noAreaPhonereg = /^[1-9]\d{6,7}$/ // 无区号固话
  rule.phonetype = rule.phonetype || 'mobile'
  if (rule.phonetype === 'mobile') {
    if (value && !mobilereg.test(value))
      callback(new Error(i18n.t('common.validatePhone')))
    else callback()
  }

  if (rule.phonetype === 'phone') {
    if (value && !phonereg.test(value))
      callback(new Error(i18n.t('common.validatePhone')))
    else callback()
  }

  if (rule.phonetype === 'all') {
    if (value && !phonereg.test(value) && !mobilereg.test(value))
      callback(new Error(i18n.t('common.validatePhone')))
    else callback()
  }

  if (rule.phonetype === 'allAndNoArea') {
    if (
      value &&
      !phonereg.test(value) &&
      !mobilereg.test(value) &&
      !noAreaPhonereg.test(value)
    )
      callback(new Error(i18n.t('common.validatePhone')))
    else callback()
  }
}


</script>

<style scoped>
.el-form {
  /*width: 100%;*/
  max-width: 500px;
}

.main {
  display: flex;
  flex-wrap: wrap;
}

.el-divider--horizontal {
  width: 100px;
  margin: 10px 0;
}

.el-divider {
  background-color: #257ac7;
}

.explain {
  width: 400px;
  margin: auto;
  margin-top: 20px
}

/deep/ .evidence-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .evidence-uploader .el-upload:hover {
  border-color: #409EFF;
}

/deep/ .evidence-uploader-icon .el-upload--picture-card {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}


@media screen {
  /deep/ .el-form--label-top .el-form-item__label {
    padding: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AddCustomer.vue